var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zeus-content"},_vm._l((_vm.pageList),function(page){return _c('page',{key:page.id,attrs:{"data":page}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }